var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"name":"container_conciencia"}},[_c('ConcienciaCRUD',{attrs:{"tipo":_vm.tipo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }